import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageStack = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})

const Header = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    paddingX: '4px',
    paddingY: '8px',
  },
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '32px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '560px',
  },
})

export { PageStack, Header, PageTitle, PageSubtitle }
